import { render, staticRenderFns } from "./AllowanceForm.vue?vue&type=template&id=f6efd594&"
import script from "./AllowanceForm.vue?vue&type=script&lang=js&"
export * from "./AllowanceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports